export const reviewData = [
    {
        id: 1,
        reviewer: "Отзыв ученика",
        video: "/reviews/review1.jpg",
        date: "23.01.2025"
    },
    {
        id: 2,
        reviewer: "Отзыв ученика",
        video: "/reviews/review1.jpg",
        date: "23.01.2025"
    },
    {
        id: 3,
        reviewer: "Отзыв ученика",
        video: "/reviews/review1.jpg",
        date: "23.01.2025"
    },
    {
        id: 4,
        reviewer: "Отзыв ученика",
        video: "/reviews/review1.jpg",
        date: "23.01.2025"
    },
    {
        id: 5,
        reviewer: "Отзыв ученика",
        video: "/reviews/review1.jpg",
        date: "23.01.2025"
    },
    {
        id: 6,
        reviewer: "Отзыв ученика",
        video: "/reviews/review1.jpg",
        date: "23.01.2025"
    }
]